import React from 'react';
import EventDetailsShell from './event-details/EventDetailsShell';
import { EventDetailsProvider, useEventDetails } from './event-details/EventDetailsContext';

const EventDetailsContent: React.FC = () => {
  const { loading, event } = useEventDetails();

  if (loading) {
    return <div className="panel-card p-6">Cargando…</div>;
  }

  if (!event) {
    return <div className="panel-card p-6">Evento no encontrado.</div>;
  }

  return <EventDetailsShell />;
};

const EventDetails: React.FC = () => {
  return (
    <EventDetailsProvider>
      <EventDetailsContent />
    </EventDetailsProvider>
  );
};

export default EventDetails;
